export class AG_GRID {
    static readonly MIN_LENGTH_TEXT_SEARCH = 2;
}